module.exports = __webpack_public_path__ + "static/img/construction-2.9abd733.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/construction-2.jpg
// module id = s3a8
// module chunks = 0